import React from 'react'
import { FormattedMessage } from 'react-intl'
import { DEFAULT_ERROR_KEY } from 'lib/core/resources/constants'
import { Container } from '../Styled'
import { Message } from '../../'

export const Failure: React.FC<Message> = ({ messageId, message }) => (
  <Container
    state='danger'
  >
    <div>
      <strong>
        {message ?? (
          <FormattedMessage
            id={messageId ?? DEFAULT_ERROR_KEY}
          />
        )}
      </strong>
    </div>
  </Container>
)
